import type { UserRole } from '../contexts/AuthContext';

/**
 * MFA enforcement policy.
 *
 * ENFORCE_MFA is OFF by default and MUST stay off until BOTH are true:
 *   1. Google Cloud Identity Platform (multi-factor) is enabled on the Firebase
 *      project — without it, TOTP enrollment throws and a forced-enrollment gate
 *      would lock high-privilege users out entirely.
 *   2. Affected users have been told to enroll (Settings → Security).
 *
 * When enabled, users whose role is in MFA_REQUIRED_ROLES are routed to the
 * enrollment gate until they have a second factor. They are signed in, so they
 * can complete enrollment themselves — this is a gate, not a lockout.
 */
export const ENFORCE_MFA = false;

export const MFA_REQUIRED_ROLES: UserRole[] = ['Owner', 'Administrator'];

/** Whether the given role must have MFA enrolled (respects the ENFORCE_MFA flag). */
export const roleRequiresMfa = (role: UserRole | undefined | null): boolean =>
  ENFORCE_MFA && !!role && MFA_REQUIRED_ROLES.includes(role);

/** Path of the forced-enrollment gate; exempt from the gate to avoid a redirect loop. */
export const MFA_ENROLL_PATH = '/enroll-mfa';
